import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { Routes, RouterModule } from '@angular/router';
import { Route } from '@app/core/route.service';

const routes: Routes = Route.withShell([
  { path: 'users', component: UsersComponent, data: { title: 'Users' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class UsersRouteModule { }
